module.exports = "pegasus_template/assets/blocks/header-3-tech.png";